export default __webpack_public_path__ + "assets/images/aa21aab29b28337a170c5399dab27af4.png";